import { getPendingScores, removeScore } from "./utils/db/scoresDB";
import { sendScore } from "./utils/api/scoresAPI";

// Fonction de synchronisation des scores stockés en local
async function syncScores() {
    console.log("Tentative de synchronisation des scores en attente...");
    const scores = await getPendingScores();

    for (const score of scores) {
        const success = await sendScore(score);
        if (success) {
            await removeScore(score.id);
            console.log(`Score ${score.id} synchronisé !`);
        }
    }
}

// Écoute le retour en ligne et tente une synchronisation
window.addEventListener("online", async () => {
    console.log("Connexion rétablie, tentative de synchronisation...");
    await syncScores();
});

// Enregistrement du Background Sync si disponible
if ('serviceWorker' in navigator && 'SyncManager' in window) {
    navigator.serviceWorker.ready.then((sw) => {
        sw.sync.register('syncScores').catch(err => {
            console.warn("Impossible d'enregistrer le Background Sync", err);
            syncScores(); // Fallback si non supporté
        });
    });
}
